/**
 * Copyright (c) 2018 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
export var CoarseHierarchy;
(function (CoarseHierarchy) {
    CoarseHierarchy.Empty = { isDefined: false };
})(CoarseHierarchy || (CoarseHierarchy = {}));
//# sourceMappingURL=hierarchy.js.map